import { DashOtif } from "../../components/classes/DashOtif";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function DashboardOtifGrid(
    props: DashboardOtifGridPropsTypes
) {
    const { t } = useTranslation();

    const [rows, setRows] = useState<Data>([]);
    const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);

    const columns: GridColumns = [
        {
            field: "id",
            headerName: t("common.id"),
            width: 80,
            align: "center",
            headerAlign: "center",
            renderHeader: (item) => {
                return <div>#</div>;
            },
        },
        {
            field: "descricaoFornecedorSap",
            headerName: t("common.partner"),
            type: "string",
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "dia",
            headerName: t("common.date"),
            type: "date",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
            },
        },
        {
            field: "semana",
            headerName: t("common.week"),
            type: "date",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{`Semana ${item.value}`}</p>;
            },
        },
        {
            field: "otif",
            headerName: t("pages.dashboardProductionMonitoring.text.otif"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return item.row.otif == 100 ? <AssignmentTurnedInIcon color="success" /> : <AssignmentLateIcon color="warning" />;
            },
        },
        {
            field: "statusEntrega",
            headerName: t("common.status"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "numeroContrato",
            headerName: t("common.contract"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "sku",
            headerName: t("common.sku"),
            type: "string",
            width: 110,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "descricao",
            headerName: t("common.description"),
            type: "string",
            width: 320,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadePlanejada",
            headerName: t("common.plannedQuantity"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadeProduzida",
            headerName: t("common.producedQuantity"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "desvio",
            headerName: t("common.deviation"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "justificativa",
            headerName: t("common.justify"),
            type: "string",
            width: 280,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "compensa",
            headerName: t("common.recover"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{item.value ? t("common.yes") : t("common.no")}</p>;
            },
        },
        {
            field: "dataCompensacao",
            headerName: t("common.compensationDate"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{!item.value ? '' : new Date(item.value).toLocaleDateString("pt-BR")}</p>;
            },
        },
        {
            field: "semanaCompensacao",
            headerName: t("common.compensationWeek"),
            type: "string",
            width: 180,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return <p>{item.value == 0 ? '' : `${t("common.week")} ${item.value}`}</p>;
            },
        },
    ];

    useEffect(() => {
        if (props.data) {
            fillTable();
        }
    }, [props]);

    const fillTable = () => {
        let gridData: Data = [];
        props.data?.forEach(
            (item: DashOtif, index: number) => {
                let json = JSON.parse(DashOtif.toJson(item));
                json.id = index;
                gridData.push(json);
            }
        );
        setRows(gridData);
    }

    return (
        <div style={{ height: "60vh", width: "100%", marginTop: 15 }}>
            <div className="containerToolbar">
                <Tooltip title={t("pages.dashboardProductionMonitoring.text.downloadCsv")}>
                    <span>
                        <IconButton onClick={() => setOpenDownloadCSVModal(true)}>
                            <Download />
                        </IconButton>
                    </span>
                </Tooltip>
            </div>
            <DataGrid
                rows={rows}
                columns={columns}
                rowsPerPageOptions={[50, 100, 250, 500]}
            />

            <Modal
                open={openDownloadCSVModal}
                onClose={() => setOpenDownloadCSVModal(false)}
                sx={{
                    display: "flex",
                    "justifyContent": "center",
                    "alignItems": "center",
                }}
            >
                <>
                    <DownloadCSVModal
                        handleClose={() => setOpenDownloadCSVModal(false)}
                        rows={rows}
                        columns={columns}
                        name={t("pages.dashboardProductionMonitoring.pageTitle")}
                    />
                </>
            </Modal>
        </div>
    );
}

interface DashboardOtifGridPropsTypes {
    data?: DashOtif[]
}